import { useGlobalStore } from '../../core/';
import { useEffect } from 'react';

export function useGlobalEvents() {
  const [scrollTop, scrollHeight, height, percent] = useGlobalStore(
    ({ scrollTop, viewport: { height, scrollHeight } }) => {
      const percent = ((scrollTop + height) / scrollHeight) * 100;
      return [scrollTop, scrollHeight, height, percent];
    },
  );

  useEffect(() => {
    const customEvent = new CustomEvent('@@vev', {
      detail: {
        type: 'onScroll',
        contentKey: 'global',
        args: {
          scrollTop,
          scrollHeight,
          height,
          percent,
        },
      },
    });
    window.dispatchEvent(customEvent);
  }, [scrollTop, scrollHeight, height, percent]);
}
